@if (!fullPageLoader) {
  <div
    [ngStyle]="{ background: 'url(' + track?.images.original + ') no-repeat center / cover' }"
  >
    <div class="track-item-page__overlay">
      <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
        <bmcore-track-item-header [beat]="track" [showBeatmakerName]="checkIsBMSTV()"></bmcore-track-item-header>
      </div>
    </div>
  </div>
  <!-- Similar tracks -->
  <div class="similar-tracks theme-beatsBlockBeatPage__bg" [ngClass]="{ 'similar-tracks--bmstv': checkIsBMSTV() }">
    <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
      <h4 class="common-section-title similar-tracks__title theme-beatsBlockBeatPage__title">
        {{ lg.tracksBlock.similarTracks }}
      </h4>
      @for (track of spotlightTracks; track track) {
        <bmcore-track-item [track]="track" [isShowFavBtn]="checkIsBMSTV()" (setPlaylistEvent)="setPlaylist()">
        </bmcore-track-item>
      }
    </div>
  </div>
  <!-- Licenses for track -->
  <div class="license theme-licenseBlockBeatPage__bg">
    <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
      <h4 class="common-section-title theme-licenseBlockBeatPage__title">
        {{ lg.licenseBlock.heading }}
      </h4>
      <bmcore-license-slider
        [licenses]="licenses"
        [licenseBulkDiscounts]="licenseBulkDiscounts"
        [btnInLicenseName]="'add to cart'"
      >
      </bmcore-license-slider>
    </div>
  </div>
  <!-- Comments block -->
  <!--<div class="common-section-wrapper">
  <div class="common-container">
    <bmcore-comments></bmcore-comments>
  </div>
</div>-->
} @else {
  <div class="bm--loader-box">
    <bmcore-loader></bmcore-loader>
  </div>
}
